import SizePresets from '@images/key-capabilities/SizePresets.png';
import Filters from '@images/key-capabilities/Filters.png';
import { ReactComponent as JavaScript } from '@assets/images/imgly/javascript.svg';
import { ReactComponent as Angular } from '@assets/images/imgly/angular.svg';
import { ReactComponent as ReactIcon } from '@assets/images/imgly/react.svg';
import { ReactComponent as Vue } from '@assets/images/imgly/vue.svg';
import { ReactComponent as Svelte } from '@assets/images/imgly/svelte.svg';
import { ReactComponent as NextJs } from '@assets/images/imgly/nextjs.svg';
import { ReactComponent as Electron } from '@assets/images/imgly/electron.svg';
import { ReactComponent as Server } from '@assets/images/imgly/server.svg';
import { ReactComponent as Apple } from '@assets/images/imgly/apple.svg';
import { ReactComponent as Android } from '@assets/images/imgly/android.svg';
import { ReactComponent as NodeJS } from '@assets/images/imgly/nodejs.svg';
import * as React from 'react';
export default {
  SizePresets,
  Filters,
  JavaScript,
  Angular,
  ReactIcon,
  Vue,
  Svelte,
  NextJs,
  Electron,
  Server,
  Apple,
  Android,
  NodeJS,
  React
};